'use client'

import { Card, Col, Typography } from '@repo/ui/components'
import { useTranslate } from '@repo/shared/hooks'
import {
  HistoryChanges,
  ValueWithUnit,
  PaymentType,
  TransactionsChart,
} from '@repo/shared/components'
import { useGetProjectDetails, useUserPortfolio } from '@repo/services'
import { useIsDesktop } from '@repo/ui/hooks'

export const BalanceProjectDetails = ({ projectId }: { projectId: string }) => {
  const { t } = useTranslate()
  const { data: { data } = {} } = useUserPortfolio()
  const isDesktop = useIsDesktop()

  const { data: response } = useGetProjectDetails(projectId)
  const projectData = response?.data.project || {}

  const projectUserData = data?.accounts?.find(
    (account) => account.type === 'project' && account.currency === projectId,
  )

  const changes = [
    {
      label: t('common_change_24h'),
      value: projectUserData?.delta24H?.amount ?? 0,
      percent: projectUserData?.delta24H?.percent ?? 0,
    },
    {
      label: t('common_change_7d'),
      value: projectUserData?.delta7D?.amount ?? 0,
      percent: projectUserData?.delta7D?.percent ?? 0,
    },
    {
      label: t('common_change_30d'),
      value: projectUserData?.delta30D?.amount ?? 0,
      percent: projectUserData?.delta30D?.percent ?? 0,
    },
  ]

  return (
    <Card className='w-full mb-xs' withoutBorder={!isDesktop}>
      <Col className='gap-md text-neutral-surface-60 items-center'>
        <div className='flex flex-row  gap-xs justify-around w-full  border-y border-neutral-surface-dark py-md md:py-0 md:border-none'>
          <Col className='items-center md:w-[121px] gap-xs'>
            <Typography size='xs' className='text-center'>
              {t('walletPage_your_assets')}
            </Typography>
            {projectData.kind === 'property' && (
              <ValueWithUnit
                value={(projectUserData?.availableBalance ?? 0) / 10_000}
                valueSize='sm'
                unitSize='2xs'
                unit='m2'
                valueWeight='bold'
                scale={projectData.scale}
                approximately
              />
            )}
            <ValueWithUnit
              value={projectUserData?.availableBalance ?? 0}
              valueSize='2xs'
              unitSize='2xs'
              valueWeight='regular'
              scale={projectData.scale}
              unit={projectData.kind === 'crypto' ? 'crypto' : 'property'}
            />
          </Col>
          <Col className='items-center md:w-[121px] gap-xs'>
            <Typography size='xs' className='text-center'>
              {t('walletPage_your_assets_approximate_value')}
            </Typography>
            <PaymentType
              value={projectUserData?.estimatedAvailableBalance}
              numberSize='sm'
              size='2xs'
            />
          </Col>
          {projectData.kind !== 'crypto' && (
            <Col className='items-center md:w-[121px] gap-xs'>
              <Typography size='xs' className='text-center'>
                {t('walletPage_total_meters')}
              </Typography>
              {projectData.kind === 'property' && (
                <ValueWithUnit
                  value={(projectData?.market?.maxSupply ?? 0) / 10_000}
                  valueSize='sm'
                  unitSize='2xs'
                  unit='m2'
                  scale={projectData.scale}
                  approximately
                />
              )}

              <ValueWithUnit
                value={projectData?.market?.maxSupply ?? 0}
                valueSize='2xs'
                unitSize='2xs'
                valueWeight='regular'
                unit={projectData.kind === 'crypto' ? 'crypto' : 'property'}
                scale={projectData.scale}
              />
            </Col>
          )}
          {/* <Col className='items-center w-[150px] gap-xs'>
            <Typography size='2xs' className='text-center'>
              {t('walletPage_your_contribution')}
            </Typography>
            <ValueWithUnit
							id='13'
              value={(projectUserData?.balance ?? 0) / 10_000}
              valueSize='sm'
              unitSize='2xs'
              scale={projectData.scale}
              unit='m2'
            />
          </Col> */}
        </div>

        <div className='flex flex-col md:flex-row justify-between w-full gap-md'>
          <HistoryChanges changes={changes} />
          <TransactionsChart currency={projectId} />
        </div>
      </Col>
    </Card>
  )
}
